<template>
  <div class="app flex-row align-items-center">
    <div class="container">
      <b-row class="justify-content-center">
        <b-col md="8">
          <b-card-group>
            <b-card no-body class="p-4">
              <b-card-body>
                <b-form @submit.prevent="onSend">
                  <h1>Recuperar contraseña</h1>
                  <p class="text-muted">Ingrese la nueva contraseña con la que podrá ingresar de nuevo</p>

                  <b-form-group label-for="new-pass">
                    <b-input-group class="mb-3">
                      <b-input-group-prepend>
                        <b-input-group-text>
                            <i class="icon-lock"></i>
                        </b-input-group-text>
                      </b-input-group-prepend>
                      <b-form-input
                        id="new-pass"
                        name="new-pass"
                        type="password"
                        class="form-control"
                        placeholder="Nueva contraseña"
                        data-vv-as="Nueva contraseña"
                        autocomplete="password"
                        v-validate="'required'"
                        v-model="user.password"
                        :state="this.validateState('new-pass')"
                        ref="new-pass"
                      />
                    </b-input-group>
                    <b-form-invalid-feedback :state="this.validateState('new-pass')">
                      <span v-for="error in errors.collect('new-pass')" v-bind:key="error">{{ error }}</span>
                    </b-form-invalid-feedback>
                  </b-form-group>

                  <b-form-group label-for="confirm-pass">
                    <b-input-group class="mb-3">
                      <b-input-group-prepend>
                        <b-input-group-text>
                          <i class="icon-lock"></i>
                        </b-input-group-text>
                      </b-input-group-prepend>
                      <b-form-input
                        id="confirm-pass"
                        name="confrim-pass"
                        type="password"
                        class="form-control"
                        placeholder="Confirmar contraseña"
                        data-vv-as="Confirmar contraseña"
                        autocomplete="new-password"
                        v-validate="'required|confirmed:new-pass'"
                        v-model="user.confirmar"
                        :state="this.validateState('confirm-pass')"
                      />
                    </b-input-group>
                    <b-form-invalid-feedback :state="this.validateState('confirm-pass')">
                      <span v-for="error in errors.collect('confirm-pass')" v-bind:key="error">{{ error }}</span>
                    </b-form-invalid-feedback>
                  </b-form-group>

                  <b-row>
                    <b-col cols="6">
                      <b-button
                        type="submit"
                        variant="primary"
                        block
                        :disabled="errors.any()"
                      >Enviar</b-button>
                    </b-col>
                  </b-row>
                </b-form>
              </b-card-body>
            </b-card>
          </b-card-group>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import { UserService, AuthenticationError } from "../../services/user.service";
import { TokenService } from "../../services/storage.service";
import { Promise } from 'q';
export default {
  name: "Recover",
  data() {
    return {
      isWeb: process.env.VUE_APP_IS_WEB,
      user: {
        email: '', 
        token: ''
      }
    };
  },
  methods: {
    onSend() {
      this.$validator.validateAll().then(res => {
          console.log(res);
          if (res) {
            var promise = new Promise(res => {
              res(this.$store.dispatch('auth/recoverPass',this.user));
            });
              /*var passRecover = {
                  data: this.user,
                  query:{"tokenTemporal": this.user.tokenTemporal, "email": this.user.email}
              }
              UserService.edit(passRecover)
              .then(res =>{
                  console.log(response),
                  console.log(state)
              })*/
          
            
          } else {
            this.$swal({
              type: "warning",
              title: "¡Campos obligatorios!",
              text: "Completa los Campos Obligatorios",
              showConfirmButton: false,
              timer: 3000
            });
          }
        })
        .catch(err => console.log(err));
    },
    validateState(ref) {
      if (
        this.veeFields[ref] &&
        (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      ) {
        return !this.errors.has(ref);
      }
      return null;
    }
  }
};
</script>
